import bcrypt from "bcryptjs-react";

export async function generateHashedPassword(password: string) {
  return await bcrypt.hash(password, 12)
}
export async function verifyHashedPassword(password: string, hash: string) {
  return await bcrypt.compare(password, hash)
}